import { render, staticRenderFns } from "./Sabbaticals.vue?vue&type=template&id=64d2f9fa&"
import script from "./Sabbaticals.vue?vue&type=script&lang=js&"
export * from "./Sabbaticals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports